// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5929) return "static/chunks/5929.b928fa49c8824417.js";
	if (chunkId === 4210) return "static/chunks/4210.224e6e897a82c168.js";
	if (chunkId === 1963) return "static/chunks/1963.234e8c5491ae9a4c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"155":"3db17bd2d7af150d","1197":"5398c76a30c70a2c","1782":"e826b266256f4870","4115":"6fe289c41c62bba3","4159":"3c65a6674f4356f0","5110":"4616bc9fe587b553","5318":"8ae7df8eb625509c"}[chunkId] + ".js";
};